import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Fab from '@material-ui/core/Fab';
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Zoom from '@material-ui/core/Zoom';
import Sider from "./Sider";
import { useStyles } from "./style"
import { isLogin, privateLogout } from '../../utils/Index';
import ConfirmDialog from '../modals/ConfirmationModal';
import { useLocation } from "react-router-dom";
import { Context } from '../../store/Context';

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');

    if (anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.HeadRoot}>
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

function Header(props) {
  const classes = useStyles();
  
  const [state] = useContext(Context);
  const userName = state.currentUserName || localStorage.getItem('user') || "";
  const usersub = window.innerWidth > 280 ? userName : userName.slice(0,18) + (userName.length > 20 ? "..." : "");

  const location = useLocation();

  const [dialogConfig, setDialogConfig] = useState({
    dialogOpen: false,
    actionTitle: "",
    actionDescription: "",
    onCancel: () => {},
    onConfirm: () => {},
  });

  //set the configuration of confirmation dialog
  const handleConfirmationDialogConfig = ({
    actionTitle = "",
    actionDescription,
    onConfirm,
    onCancel,
    dialogOpen,
  }) => {
    setDialogConfig({
      ...dialogConfig,
      actionTitle,
      actionDescription,
      onConfirm,
      onCancel,
      dialogOpen,
    });
  };

  //set the visibility of confirmation dialog
  const handleConfirmationDialogVisibility = value => {
    setDialogConfig({
      ...dialogConfig,
      dialogOpen: value,
    });
  };

  //Clear the localStorage and caches and reload the window after logout
  const Logout = () => {
    caches
      .keys()
      .then(keyList => Promise.all(keyList.map(key => caches.delete(key))));
    localStorage.clear();
    privateLogout();
    window.location.reload();
  };

  //getting the status of logged in or not
  const isUserLoggedIn = isLogin()

  return (
    <React.Fragment>
      <CssBaseline />
      <ConfirmDialog
        open={dialogConfig.dialogOpen}
        actionTitle={dialogConfig.actionTitle}
        actionDescription={dialogConfig.actionDescription}
        type="confirm"
        onCancel={dialogConfig.onCancel}
        onConfirm={dialogConfig.onConfirm}
      />
      <AppBar >
        <Toolbar>
          {isUserLoggedIn && <Sider />}
          <div style={{ flex: "1 1 0%" }} />
          <h3>{usersub}</h3>
          {isUserLoggedIn && (
            <Tooltip title="Logout" arrow> 
            <ExitToAppIcon
              aria-label="Logout"
              className={classes.logo}
              onClick={() => {
                handleConfirmationDialogConfig({
                  actionDescription: "Do you want to Logout ?",
                  actionTitle: "Logout",
                  type: "confirm",
                  onConfirm: () => Logout(),
                  onCancel: () => handleConfirmationDialogVisibility(false),
                  dialogOpen: true,
                });
              }}
            />
            </Tooltip>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar id="back-to-top-anchor" />
      <ScrollTop {...props}>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </React.Fragment>
  );
}

export default Header;
